(function ($) {

  Drupal.behaviors.applicationFormNavigation = {
	attach: function (context) {
		Drupal.behaviors.applicationFormNavigationCreator(context);
	}
  }

  Drupal.behaviors.applicationFormNavigationCreator = function (context) {
	var applicationFormNavigationContainer = $(".applicationFormNavigation",context);
  	var isAlreadyModified = $(applicationFormNavigationContainer).data("saph-done");
  	if(isAlreadyModified){
  		return true;
  	}
  	if(applicationFormNavigationContainer.length <= 0){
  		return true;
  	}
  	Drupal.behaviors.functions.consolog("applicationFormNavigationScroll Creator");


	$(".applicationFormNavigation-link",applicationFormNavigationContainer).addClass("link-secondary");
	$(".applicationFormNavigation-link", applicationFormNavigationContainer).click(function(event) {
		event.preventDefault();
		var dest = $(this).data("anchor");

		var offsetForHeader = 0;
		if($(".applicationFormNavigation-link").first().attr('id') != $(this).attr('id')){
			offsetForHeader = Drupal.behaviors.minHeightOfNavBar();
		}
		$('html,body').animate({scrollTop: $("#" + dest).offset().top},'slow',function() {
			location.hash = dest;
		});

	});

	$(window).scroll(function() {
		Drupal.behaviors.applicationFormNavigationScrollCreator($(this));
	});

	$(applicationFormNavigationContainer).data("saph-done",true);
	Drupal.behaviors.applicationFormNavigationScrollCreator($(window));

  }

  Drupal.behaviors.applicationFormNavigationScrollCreator = function(mainContent)
  {
		//Drupal.behaviors.functions.consolog("applicationFormNavigationScroll Active");
		if($(".applicationFormNavigation").length <= 0 || !$(".applicationFormNavigation").data("saph-done")){
			return true;
		}
		var scrollTop = $(mainContent).scrollTop();

		//Make everything unactive;
		$(".applicationFormNavigation-link").removeClass("link-primary");
		$(".applicationFormNavigation-link").addClass("link-secondary");
		$(".application-form-submenu-anchor").removeClass("application-form-submenu-selected");

		var lastElementScrollPoint = 0;
		//var offsetForHeader = Drupal.behaviors.minHeightOfNavBar();
	    	$(".application-form-submenu-anchor").each(function (index){

	    		var isThisPointActive = false;
	    		var anchorID = $(".applicationFormNavigation-link",this).data("anchor");

	    		//var topScrollPoint;
	    		/*
	    		if($(".applicationFormNavigation-link").first().data('anchor') != $(".applicationFormNavigation-link",this).data('anchor')){
	    			topScrollPoint = $("#" + anchorID).offset().top;
	    		}
	    		else{
	    			topScrollPoint = $("#" + anchorID).offset().top;//-offsetForHeader;
	    		}
	    		*/

          var topScrollPoint = $("#" + anchorID).offset().top-100;

          var nextAnchorID = $($(".applicationFormNavigation-link")[index+1]).data("anchor");
	    		if($(".applicationFormNavigation-link").last().data('anchor') == $(".applicationFormNavigation-link",this).data('anchor')){
	    			var scrollHeight = $(document).height();
	    			var scrollPosition = $(mainContent).height() + scrollTop;

	    			if(scrollTop >= topScrollPoint || ((scrollHeight - scrollPosition) / scrollHeight === 0)){
	    				isThisPointActive = true;
	    			}
	    		}else{
	    			var nextAnchorID = $($(".applicationFormNavigation-link")[index+1]).data("anchor");
	    			if(nextAnchorID == $(".applicationFormNavigation-link").last().data('anchor')){
	    				//If the next one is the last one check it first
		    			var scrollHeight = $(document).height();
		    			var scrollPosition = $(mainContent).height() + scrollTop;
		    			if((scrollHeight - scrollPosition) / scrollHeight === 0){
		    				var lastElement = $(".application-form-submenu-anchor").last();
		    				$(".applicationFormNavigation-link",lastElement).addClass("link-primary");
		    				$(".applicationFormNavigation-link",lastElement).removeClass("link-secondary");
		    				$(lastElement).addClass("application-form-submenu-selected");
		    				return false;
		    			}
	    			}
	    			var endScrollPoint = $("#" + nextAnchorID).offset().top;
	    			if(scrollTop >= topScrollPoint && scrollTop < endScrollPoint){
	    				isThisPointActive = true;
	    			}
	    		}
	    		if(isThisPointActive){

            //Make everything unactive;
            $(".applicationFormNavigation-link").removeClass("link-primary");
            $(".applicationFormNavigation-link").addClass("link-secondary");
            $(".application-form-submenu-anchor").removeClass("application-form-submenu-selected");

	    			//Set classes to active
	    			$(".applicationFormNavigation-link",this).addClass("link-primary");
	    			$(".applicationFormNavigation-link",this).removeClass("link-secondary");
	    			$(this).addClass("application-form-submenu-selected");

            //end cycle
	    			//return false;
	    		}
	    	});
	}
})(jQuery);
